module.exports = __webpack_public_path__ + "static/media/occlusion_ru.06feda4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/occlusion_ru.svg
// module id = 1075
// module chunks = 0